module.exports = __webpack_public_path__ + "2ce442f27792ba2cca490d9d907b6561.pdf";